export const OPTIONAL_PERSONAL_COLUMNS = [
  { key: "dob", label: "Date of Birth" },
  { key: "aadhar", label: "Aadhar Number" },
  { key: "pan", label: "PAN Number" },
  { key: "esi", label: "ESI Number" },
  { key: "pf", label: "PF Number" },
  { key: "uan", label: "UAN Number" },
  { key: "gender", label: "Gender" },
  { key: "marital_status", label: "Marital Status" },
  { key: "address", label: "Communication Address" },
  { key: "permanent_address", label: "Permanent Address" },
  { key: "account_holder_name", label: "Account Holder Name" },
  { key: "accountno", label: "Account Number" },
  { key: "bankname", label: "Bank Name" },
  { key: "bank_address", label: "Bank Address" },
  { key: "ifsc", label: "IFSC" },
  { key: "emergency_contact_name", label: "Emergency Contact Name" },
  { key: "emergency_relation_type", label: "Emergency Relation Type" },
  { key: "emergency_contact_number", label: "Emergency Contact Number" },
  { key: "transport_type", label: "Employee Use" },
  { key: "block_name", label: "Block Name" },
  { key: "room_no", label: "Room No" },
];
